import React, { useId } from "react";

const suffixIds = (node, suffix) => {
  if (!React.isValidElement(node)) return node;
  const props = {};
  Object.keys(node.props).forEach((key) => {
    const value = node.props[key];
    if (key === "children") {
      props.children = React.Children.map(value, (child) =>
        suffixIds(child, suffix)
      );
    } else if (typeof value === "string") {
      props[key] = value.replace(/url\(#([^)]+)\)/g, `url(#$1${suffix})`);
    }
  });
  if (typeof node.props.id === "string") {
    props.id = `${node.props.id}${suffix}`;
  }
  return React.cloneElement(node, props);
};

const withUniqueIds = (Icon) => (props) => {
  const suffix = useId().replace(/:/g, "");
  return suffixIds(Icon(props), suffix);
};

export default withUniqueIds;
